import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Container } from "@mui/material";
// import catImage from "../images/homecat.png";
import catImage from "../images/homecat1.avif";
// import dogImage from "../images/homeimg.png";
import dogImage from "../images/homeimg.avif";
import logo from "../images/logo.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import Navbarsmall from "../components/Navbarsmall";
import { useAuth } from "../components/AuthContext";

const FurbabiesHome = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [showPwModal, setShowPwModal] = useState(
    localStorage.getItem("mustChangePassword") === "true"
  );
  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  const buttonVariants = {
    hover: { backgroundColor: "#BDA697", transition: { duration: 0.3 } },
  };

  const imageVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <section className="relative  pt-16">
      <span className="xl:hidden">
        <Navbarsmall />
      </span>
      <motion.nav
        // initial={{ x: "-100%" }}
        // animate={{ x: 0 }}
        // transition={{ duration: 0.5 }}
        className="fixed top-0 left-0 h-full w-1/8 md:w-1/8 bg-[#E8E1DA] space-y-8 z-50 xl:block hidden  flex-col justify-between"
      >
        <div className="text-4xl font-bold text-center text-gray-800">
          <a href="/" target="_blank" rel="noopener noreferrer">
            <img src={logo} alt="Logo" className="w-44 h-44 mx-auto" />
          </a>
        </div>

        <motion.ul
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 0.8 }}
          className="text-[#967d6c] font-semibold flex-grow"
        >
          <motion.li
            // initial={{ x: -20, opacity: 0 }}
            // animate={{ x: 0, opacity: 1 }}
            // transition={{ duration: 0.6 }}
            className="w-full"
          >
            <NavLink
              to="/furhome"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#967d6c] text-white w-full px-4 pt-3 pb-4 text-xl block"
                  : "hover:bg-[#bda697]  w-full px-4 pt-3 pb-4  text-xl block"
              }
            >
              Home
            </NavLink>
          </motion.li>

          <motion.li
            // initial={{ x: -20, opacity: 0 }}
            // animate={{ x: 0, opacity: 1 }}
            // transition={{ duration: 0.7 }}
            className="w-full"
          >
            <NavLink
              to="/pet-health"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#967d6c] text-white w-full px-4 pt-3 pb-4 rounded-md text-xl"
                  : "hover:bg-[#bda697]  w-full px-4 pt-3 pb-4  text-xl block"
              }
            >
              Pet Health
            </NavLink>
          </motion.li>

          <motion.li
            // initial={{ x: -20, opacity: 0 }}
            // animate={{ x: 0, opacity: 1 }}
            // transition={{ duration: 0.8 }}
            className="w-full"
          >
            <NavLink
              to="/pet-nutrition"
              className={({ isActive }) =>
                isActive
                  ? "bg-[#967d6c] text-white w-full px-4 pt-3 pb-4 rounded-md text-xl"
                  : "hover:bg-[#bda697]  w-full px-4 pt-3 pb-4  text-xl block"
              }
            >
              Pet Nutrition
            </NavLink>
          </motion.li>
        </motion.ul>

        <motion.div
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 0.8 }}
          className="w-full"
        >
          <NavLink
            to="#"
            onClick={handleLogout}
            className="hover:text-gray-800 poppins-text  text-[#967d6c] w-full px-4 py-2 mt-96 text-xl bg-transparent focus:outline-none text-center block"
          >
            Logout
          </NavLink>
        </motion.div>
      </motion.nav>

      <div className="absolute top-20 xl:block hidden right-20 z-50">
        <Link to="/account">
          <motion.div
            className="text-5xl text-[#967d6c]"
            whileHover={{ scale: 1.2 }}
            transition={{ duration: 0.3 }}
          >
            <FaUserCircle />
          </motion.div>
        </Link>
      </div>

      <Container maxWidth="md" className="xl:mt-2 mt-20 xl:text-left  mr-10 ">
        <motion.h1
          variants={textVariants}
          initial="hidden"
          animate="visible"
          className="lg:text-[60px] lg:leading-[70px] text-5xl font-bold text-gray-900"
        >
          Love Your Furbaby Right
        </motion.h1>
        <motion.p
          variants={textVariants}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.2 }}
          className="mt-4 text-xl lg:text-[20px] lg:leading-[28px] poppins-text text-gray-600"
        >
          Because their happiness is your happiness.
        </motion.p>

        <div className="mt-16 flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-10">
          <motion.div className="flex">
            <Link to="/pet-health">
              <motion.button
                variants={buttonVariants}
                whileHover="hover"
                whileTap={{ backgroundColor: "#967d6c" }}
                className="text-xl lg:text-[20px] lg:leading-[26px] px-12 py-4 bg-[#967d6c]  text-white font-bold rounded-full"
              >
                Go To Pet Health
              </motion.button>
            </Link>
          </motion.div>

          <motion.div className="flex">
            <Link to="/pet-nutrition">
              <motion.button
                variants={buttonVariants}
                whileHover="hover"
                whileTap={{ backgroundColor: "#967d6c" }}
                className="text-xl lg:text-[20px] lg:leading-[26px] px-12 py-4 bg-[#967d6c]  text-white font-bold rounded-full"
              >
                Feed Your Furbaby
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </Container>

      <motion.div
        className="absolute left-36 top-96 hidden xl:block"
        variants={imageVariants}
        initial="hidden"
        animate="visible"
      >
        <img
          src={catImage}
          alt="Cat"
          className="h-[30rem] mx-auto "
          loading="lazy"
        />
        <div className="absolute left-60 bottom-20 transform -translate-x-1/2 hidden lg:block">
          <div className="text-6xl  text-[#bda697] animate-paw-left-right">
            <i className="fa fa-paw"></i>
          </div>
        </div>
        <div className="absolute bottom-52 right-1  transform translate-x-1/2 hidden lg:block">
          <div className="text-4xl text-[#bda697] animate-paw-right-left">
            <i className="fa fa-paw"></i>
          </div>
        </div>
      </motion.div>

      <motion.div
        className="absolute right-0 top-72 hidden xl:block"
        variants={{ ...imageVariants, hidden: { opacity: 0, x: 100 } }}
        initial="hidden"
        animate="visible"
      >
        <img
          src={dogImage}
          alt="Dog"
          className="h-[30rem] mx-auto"
          loading="lazy"
        />

        <div className="absolute right-20  hidden xl:block">
          <div className="text-4xl text-[#bda697] animate-paw-left-right">
            <i className="fa fa-paw"></i>
          </div>
        </div>
        <div className="absolute right-52 bottom-16 hidden xl:block">
          <div className="text-6xl text-[#bda697] animate-paw-left-right">
            <i className="fa fa-paw"></i>
          </div>
        </div>
      </motion.div>

      {/* Must-change-password modal */}
      <AnimatePresence>
        {showPwModal && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/50 z-[300]"
            />
            <motion.div
              initial={{ opacity: 0, scale: 0.92, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.92, y: 20 }}
              transition={{ type: "spring", stiffness: 320, damping: 32 }}
              className="fixed z-[301] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-3xl shadow-xl p-8 w-full max-w-sm mx-4"
            >
              <div className="flex flex-col items-center text-center gap-3">
                <div className="text-4xl text-amber-400">
                  <i className="fa fa-paw" />
                </div>
                <h2 className="text-xl font-bold text-gray-900">
                  Please change your password
                </h2>
                <p className="text-sm text-gray-500 poppins-text">
                  You're using a temporary password. Update it now to secure your account.
                </p>
                <motion.button
                  whileHover={{ backgroundColor: "#BDA697" }}
                  whileTap={{ scale: 0.97 }}
                  onClick={() => { setShowPwModal(false); navigate("/account"); }}
                  className="mt-2 w-full bg-[#967d6c] text-white font-bold py-3 rounded-full poppins-text"
                >
                  Change Password
                </motion.button>
                <button
                  onClick={() => setShowPwModal(false)}
                  className="text-sm text-gray-400 hover:text-gray-600 poppins-text"
                >
                  Remind me later
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </section>
  );
};

export default FurbabiesHome;
